import React from 'react';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import {ShowTooltip} from '../../components/Tooltip';
import {useInputFocus} from '../hooks';
import {FieldWrapper} from '../index';

export const Radio = ( {
                           id,
                           name,
                           label,
                           value,
                           tooltip,
                           disabled,
                           recede,
                           disabledTooltip,
                           isFocused,
                           toggleable,
                           labelClassName,
                           inputClassName,
                           ...props
                       } ) => {

    const {fieldRef} = useInputFocus( isFocused );

    return (
        <FieldWrapper name={name} disabled={disabled} disabledTooltip={disabledTooltip}>
            {( {field, form} ) => {
                const fieldValue = field.value && field.value.toString() || '';
                const isChecked = fieldValue.includes( value );
                const checkboxClasses = cx( 'radio', {
                    'checked': isChecked,
                    'disabled': disabled,
                    'recede': recede
                } );

                // render as child prop
                if ( typeof props.children === 'function' ) {
                    return (
                        <label className={cx( 'font-normal m-0', labelClassName )} htmlFor={id}>
                            <input
                                ref={fieldRef}
                                className="hidden"
                                type="radio"
                                name={name}
                                id={id}
                                title={label}
                                disabled={disabled}
                                value={value}
                                checked={isChecked}
                                onClick={() => {
                                    if ( isChecked && toggleable ) {
                                        form.setFieldValue( name, '' );
                                    }
                                    invoke( props, 'onClick', value );
                                }}
                                onBlur={( e ) => {
                                    form.handleBlur( e );
                                    invoke( props, 'onBlur', value );
                                }}
                                onChange={e => {
                                    form.setFieldValue( name, value );
                                    invoke( props, 'onChange', value );
                                }}
                            />
                            {props.children( {
                                field,
                                form,
                                id,
                                name,
                                label,
                                value,
                                tooltip,
                                disabled,
                                inputClassName,
                                isChecked,
                                ...props
                            } )}
                        </label>
                    );
                }

                return (
                    <div>
                        <label className={cx( 'font-normal', {'text-grey': disabled}, labelClassName )}>
                            <span className={cx( inputClassName, 'wrap-check mr-2 flex-none' )}>
                                <input
                                    {...props}
                                    ref={fieldRef}
                                    type="radio"
                                    name={name}
                                    id={id}
                                    title={label}
                                    disabled={disabled}
                                    value={value}
                                    checked={isChecked}
                                    onBlur={form.handleBlur}
                                    onChange={e => {
                                        form.setFieldValue( name, value );
                                        invoke( props, 'onChange', value );
                                    }}
                                />
                                <span className={checkboxClasses}></span>
                            </span>
                            {label}
                        </label>
                        <ShowTooltip useIcon tooltip={!disabled && tooltip}/>
                    </div>
                );
            }}
        </FieldWrapper>
    )
}
